var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-contenido',{attrs:{"Controlador":_vm.Controlador,"SinMenu":true,"MostrarSubTitulo":false,"SinToolbar":true}},[_c('template',{slot:"principal-derecha"},[_c('p',[_vm._v(_vm._s(_vm.Modo))])]),[_c('lista')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }